//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { area_list, oss_files } from '@/apis/config'
import { sysConfigs_stadiumConfig, sysConfigs_stadiumConfig_form } from '@/apis/system'
export default {
    data() {
        const form = {
            phone: null,
            email: null,
            address: null,
            qrcode: null,
            regisPointsExpiredDays: null,
            orderCancelTimeLimit: null,
            paisportHomeSlogan: null,
            paisportHomeIntroduce: null,
            brandYear: null,
            stadiumExtent: null,
            openArea: null
        };
        const formIntroduce = {
            introduce: null,
            institutionsNumber: null,
            employeesNumber: null,
            projectTypeNumber: null,
            memberNumber: null,
            introduceVideoImage: null,
            introduceVideoUrl: null,
        }
        const rules = {};
        const rulesIntroduce = {};
        return {
            form,
            rules,
            formIntroduce,
            rulesIntroduce,
            fileLoading: false,
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
            configData: [],
            formList: [],
            // formAddList: [],
            // formUpdateData: {},
            fileList: [],
            fileIntroduceList: [],
            provinces: [],
            areas: [],
            //新增地區範圍數據文本
            areaNameText: '',
            currentAreaCode: '',
            showUpdateAreaName: false
        }
    },
    mounted() {
        this.onPageLoad();
    },
    methods: {
        //獲取區域範圍
        async getAreaList() {
            try {
                const res = await area_list();
                if (res.code == 0) {
                    const list = res.data;
                    this.provinces = list.filter(item => item.parentCode == '7100000000000');
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },

        async onPageLoad() {
            try {
                //進行區域範圍的讀取後，再進行綁定數據讀取操作
                await this.getAreaList();
                const res = await sysConfigs_stadiumConfig();
                if (res.code == 0) {
                    this.configData = res.data;
                    this.form.phone = this.getConfigItem('phone');
                    this.form.email = this.getConfigItem('email');
                    this.form.address = this.getConfigItem('address');
                    this.form.qrcode = this.getConfigItem('qrcode');
                    this.form.orderCancelTimeLimit = this.getConfigItem('orderCancelTimeLimit');
                    this.form.paisportHomeSlogan = this.getConfigItem('paisportHomeSlogan');
                    this.form.paisportHomeIntroduce = this.getConfigItem('paisportHomeIntroduce');
                    this.form.brandYear = this.getConfigItem('brandYear');
                    this.form.stadiumExtent = this.getConfigItem('stadiumExtent');
                    this.form.openArea = this.getConfigItem('openArea');
                    console.log(this.form.openArea);
                    if (this.form.openArea) {
                        this.areas = this.form.openArea;
                    }

                    this.form.regisPointsExpiredDays = this.getConfigItem('regisPointsExpiredDays');
                    this.formIntroduce.introduce = this.getConfigItem('introduce');
                    this.formIntroduce.institutionsNumber = this.getConfigItem('institutionsNumber');
                    this.formIntroduce.employeesNumber = this.getConfigItem('employeesNumber');
                    this.formIntroduce.projectTypeNumber = this.getConfigItem('projectTypeNumber');
                    this.formIntroduce.memberNumber = this.getConfigItem('memberNumber');
                    this.formIntroduce.introduceVideoImage = this.getConfigItem('introduceVideoImage');
                    this.formIntroduce.introduceVideoUrl = this.getConfigItem('introduceVideoUrl');

                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async handleIntroduceFileChange({ fileList }) {
            if (fileList.length > 0) {
                // 過濾掉非圖片文件
                const validFiles = fileList.filter(file =>
                    file.type?.startsWith('image/') ||
                    (file.originFileObj && file.originFileObj.type.startsWith('image/'))
                );
                try {
                    this.fileLoading = true;
                    const formData = new FormData();
                    formData.append('file', validFiles[0].originFileObj);
                    const res = await oss_files('ifBG', formData);
                    if (res.code == 0) {
                        this.formIntroduce.introduceVideoImage = res.data;
                    } else {
                        this.$message.error(res.msg);
                    }
                } catch (error) {
                    this.$message.error(error.message);
                } finally {
                    this.fileLoading = false;
                }
            }
        },
        //圖片上傳
        async handleFileChange({ fileList }) {
            if (fileList.length > 0) {
                // 過濾掉非圖片文件
                const validFiles = fileList.filter(file =>
                    file.type?.startsWith('image/') ||
                    (file.originFileObj && file.originFileObj.type.startsWith('image/'))
                );
                try {
                    this.fileLoading = true;
                    const formData = new FormData();
                    formData.append('file', validFiles[0].originFileObj);
                    const res = await oss_files('ifBG', formData);
                    if (res.code == 0) {
                        this.form.qrcode = res.data;
                    } else {
                        this.$message.error(res.msg);
                    }
                } catch (error) {
                    this.$message.error(error.message);
                } finally {
                    this.fileLoading = false;
                }
            }
        },
        handleFormValidate(e) {
            e.preventDefault();
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.getFormList(this.form);
                    if (this.formInsert(this.formList)) {
                        this.$message.success('提交完成');
                    }
                    // if (this.formInsert(this.formAddList) && this.formUpdate(this.formUpdateData)) {
                    //     this.$message.success('提交完成');
                    // }
                } else {
                    return false;
                }
            });
        },
        handleIntroduceFormValidate(e) {
            e.preventDefault();
            this.$refs.formIntroduce.validate(valid => {
                if (valid) {
                    this.getFormList(this.formIntroduce);
                    if (this.formInsert(this.formList)) {
                        this.$message.success('提交完成');
                    }

                    // if (this.formInsert(this.formAddList) && this.formUpdate(this.formUpdateData)) {
                    //     this.$message.success('提交完成');
                    // }
                } else {
                    return false;
                }
            });
        },
        // async formUpdate(data) {
        //     try {
        //         const res = await sysConfigs_applicationConfig(data);
        //         if (res.code == 0) {
        //             return true;
        //         } else {
        //             if (res.msg)
        //                 throw new Error(res.msg);
        //         }
        //     } catch (error) {
        //         this.$message.error(error.message);
        //     }
        // },
        async formInsert(configArr) {
            try {
                if (configArr.length > 0) {
                    const res = await sysConfigs_stadiumConfig_form(configArr);
                    if (res.code == 0) {
                        return true;
                    } else {
                        if (res.msg)
                            throw new Error(res.msg);
                    }
                } else {
                    return true;
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },

        addAreaName() {
            const text = this.areaNameText || '';
            if (text != '') {
                //生成壹個16位的隨機字符串
                let randomString = Math.random().toString(36).substring(2, 18) + Date.now().toString(36);
                //隨機字符串轉為大寫
                const code = randomString.toUpperCase();
                this.areas.push({
                    code,
                    name: text
                });
                this.form.openArea = JSON.stringify(this.areas);
                this.areaNameText = '';
            }

        },
        updateAreaName() {
            //通過currentAreaCode 來更新對應的areaName
            const area = this.areas.find(item => item.code === this.currentAreaCode);
            if (area) {
                area.name = this.areaNameText;
                this.form.openArea = JSON.stringify(this.areas);
            } else {
                this.$message.error('找不到對應的區域代碼');
            }
            this.showUpdateAreaName = false;
            this.currentAreaCode = '';
            this.areaNameText = '';
        },
        closeUpdateAreaName() {
            this.showUpdateAreaName = false;
            this.currentAreaCode = '';
            this.areaNameText = '';
        },
        removeAreaItem(item) {
            this.areas = this.areas.filter(row => row.code !== item.code);
            this.form.openArea = JSON.stringify(this.areas);
        },
        updateAreaItem(item) {
            this.currentAreaCode = item.code;
            this.areaNameText = item.name;
            this.showUpdateAreaName = true;
        },
        getFormList(form) {
            // this.formUpdateData = {};
            // this.formAddList = [];
            this.formList = [];

            for (const key in form) {
                if (Object.hasOwnProperty.call(form, key)) {
                    const formVal = form[key];
                    this.formList.push({
                        configKey: key,
                        configVal: formVal || '',
                        configName: '',
                        configDesc: ''
                    })
                    // const val = this.getConfigItem(key);
                    // if (val) {
                    //     this.formUpdateData[key] = formVal;
                    // } else {
                    //     this.formAddList.push({
                    //         configKey: key,
                    //         configVal: formVal || '',
                    //         configName: '',
                    //         configDesc: ''
                    //     })
                    // }
                }
            }
        },
        getConfigItem(key) {
            const res = this.configData.filter(item => item.configKey == key);
            if (res.length > 0) {
                try {
                    return JSON.parse(res[0].configVal);
                } catch (error) {
                    return res[0].configVal;
                }

            } else {
                return undefined;
            }
        },
    }
}
